<div class="container-fluid">
  <div class="row">
    <h3 class="page-header">View Employees</h3>
  </div>

  <div id="table">
    <ng-container>
      <mat-label>Include Ex-Employees?:&nbsp;&nbsp;</mat-label>
      <mat-checkbox style="width: 13px" id="Include ex-employees" name="Include ex-employees"
        (click)="includeExEmployees.next(!includeExEmployees.value)"></mat-checkbox>
    </ng-container>
    <div class="row">
      <div class="col-xs-12">
        <aims-common-table id="viewEmployees-table" [dataSource]="emps | async" [header]="viewEmployeeHeader"
          [pageSize]="10" [permissions]="tablePermissions" [addRowInitialObject]="initialTableElement">

          <aims-common-table-dynamic-row id="button">
            <ng-template viewMode let-element>
              <button
                *ngIf="permissions.canCreate(permissions.ComponentID.PSC) && permissions.canUpdate(permissions.ComponentID.Employee) && !(element.employmentStatusId == PASS && element.employeeStatusId == TERMINATE)"
                type="button" mat-mini-fab color="basic" aria-label="Add PSC"
                [routerLink]="'/hr/newPsc/' + element.employeeId" title='Add PSC'>
                <mat-icon>control_point</mat-icon>
              </button>
            </ng-template>
          </aims-common-table-dynamic-row>



          <aims-common-table-dynamic-row id="jobTitle">
            <ng-template viewMode let-element>{{ element.jobTitle }}
            </ng-template>
            <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
              <mat-form-field appearance="fill" class="top20 fullWidth">
                <mat-label>Filter</mat-label>
                <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                  <mat-option label=""></mat-option>
                  <mat-option *ngFor="let val of jobTitleValues | async" [value]="val.jobTitle">
                    {{val.jobTitle}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-template>
          </aims-common-table-dynamic-row>

          <aims-common-table-dynamic-row id="assignmentDescription">
            <ng-template viewMode let-element>{{ element.assignmentDescription }}
            </ng-template>
            <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
              <!-- ToDo: would like an aims-lookup-filter here -->
              <mat-form-field appearance="fill" class="top20 fullWidth">
                <mat-label>Filter</mat-label>
                <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                  <mat-option label=""></mat-option>
                  <mat-option *ngFor="let val of employeeJobAssignmentValues | async"
                    [value]="val.assignmentDescription">
                    {{val.assignmentDescription}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-template>
          </aims-common-table-dynamic-row>

          <aims-common-table-dynamic-row id="employeeStatus">
            <ng-template viewMode let-element>{{ element.employeeStatus }}
            </ng-template>
            <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
              <mat-form-field appearance="fill" class="top20 fullWidth">
                <mat-label>Filter</mat-label>
                <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                  <mat-option label=""></mat-option>
                  <mat-option *ngFor="let val of employeeStatusValues | async" [value]="val.employeeStatus">
                    {{val.employeeStatus}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-template>
          </aims-common-table-dynamic-row>

          <aims-common-table-dynamic-row id="employmentTypeCode">
            <ng-template viewMode let-element>{{ element.employmentTypeCode }}
            </ng-template>
            <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
              <mat-form-field appearance="fill" class="top20 fullWidth">
                <mat-label>Filter</mat-label>
                <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                  <mat-option label=""></mat-option>
                  <mat-option *ngFor="let val of employmentTypeValues |
              async" [value]="val.employmentTypeCode">
                    {{val.employmentTypeCode}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-template>
          </aims-common-table-dynamic-row>

          <aims-common-table-dynamic-row id="employmentStatusCode">
            <ng-template viewMode let-element>{{ element.employmentStatusCode }}
            </ng-template>
            <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
              <mat-form-field appearance="fill" class="top20 fullWidth">
                <mat-label>Filter</mat-label>
                <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                  <mat-option label=""></mat-option>
                  <mat-option *ngFor="let val of employmentStatusValues |
              async" [value]="val.employmentStatusCode">
                    {{val.employmentStatusCode}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-template>
          </aims-common-table-dynamic-row>

          <aims-common-table-dynamic-row id="unionAffiliationCode">
            <ng-template viewMode let-element>{{ element.unionAffiliationCode }}
            </ng-template>
            <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
              <mat-form-field appearance="fill" class="top20 fullWidth">
                <mat-label>Filter</mat-label>
                <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                  <mat-option label=""></mat-option>
                  <mat-option *ngFor="let val of unionValues | async" [value]="val.unionAffiliationCode">
                    {{val.unionAffiliationCode}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-template>
          </aims-common-table-dynamic-row>

        </aims-common-table>
      </div>
    </div>
  </div>
</div>
